import { render, staticRenderFns } from "./ValueFormatedNumber.vue?vue&type=template&id=77d4eefd"
import script from "./ValueFormatedNumber.vue?vue&type=script&lang=js"
export * from "./ValueFormatedNumber.vue?vue&type=script&lang=js"
import style0 from "./ValueFormatedNumber.vue?vue&type=style&index=0&id=77d4eefd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports